import React from 'react';
import Department from './Department';

export const SEP = () => <Department departmentName="Departamento SEP" />;
export const UTP = () => <Department departmentName="Departamento UTP" />;
export const FinanceDepartments = () => <Department departmentName="Departamento Finanzas" />;
export const Acquisitions = () => <Department departmentName="Departamento Adquisiciones" />;
export const Legal = () => <Department departmentName="Departamento Jurídico" />;
export const InternalControl = () => <Department departmentName="Departamento Control Interno" />;
export const Treasury = () => <Department departmentName="Departamento Tesorería" />;